import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatDateTime, ROLE_LABELS, AUDIT_ACTION_LABELS } from "@/lib/format";
import { ScrollText, Search } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

const ACTION_COLORS = {
  user_create: "bg-emerald-100 text-emerald-700",
  user_update: "bg-sky-100 text-sky-700",
  user_delete: "bg-red-100 text-red-700",
  request_create: "bg-slate-100 text-slate-700",
  request_approve: "bg-emerald-100 text-emerald-700",
  request_reject: "bg-red-100 text-red-700",
  request_disburse: "bg-sky-100 text-sky-700",
  expense_proof: "bg-amber-100 text-amber-700",
  approver_appoint: "bg-emerald-100 text-emerald-700",
  approver_revoke: "bg-red-100 text-red-700",
};

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/audit-logs", { params: { limit: 300 } }).then((r) => setRows(r.data)).catch(() => {});
  }, []);

  const filtered = rows.filter((r) =>
    !q || r.actor_name?.toLowerCase().includes(q.toLowerCase()) ||
    (AUDIT_ACTION_LABELS[r.action] || r.action).toLowerCase().includes(q.toLowerCase()) ||
    r.detail?.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-2xl font-bold flex items-center gap-2" style={{ fontFamily: "Outfit" }}>
            <ScrollText className="h-6 w-6 text-brand" /> Log Audit Sistem
          </h2>
          <p className="text-sm text-muted-foreground">Riwayat seluruh aktivitas penting dalam sistem.</p>
        </div>
        <div className="relative w-full sm:w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari aktor / aksi / detail..."
            className="pl-9" data-testid="audit-search-input" />
        </div>
      </div>

      <Card className="p-4">
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Waktu</TableHead>
                <TableHead>Aktor</TableHead>
                <TableHead>Role</TableHead>
                <TableHead>Aksi</TableHead>
                <TableHead>Detail</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {filtered.length === 0 && (
                <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-10">Belum ada aktivitas.</TableCell></TableRow>
              )}
              {filtered.map((r) => (
                <TableRow key={r.id} data-testid={`audit-row-${r.id}`}>
                  <TableCell className="text-xs font-mono whitespace-nowrap text-muted-foreground">{formatDateTime(r.created_at)}</TableCell>
                  <TableCell className="font-medium text-sm">{r.actor_name}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{ROLE_LABELS[r.actor_role] || r.actor_role}</TableCell>
                  <TableCell>
                    <Badge className={`${ACTION_COLORS[r.action] || "bg-slate-100 text-slate-700"} border-0`}>
                      {AUDIT_ACTION_LABELS[r.action] || r.action}
                    </Badge>
                  </TableCell>
                  <TableCell className="text-sm text-muted-foreground">{r.detail || "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  );
}
